import { Link } from "react-router-dom";

const Hero = () => {
	return (
		<>
			<div className="hero bg-base-100 mb-5 text-center">
				<div className="hero-content w-1/2">
					<div>
						<h1 className="text-5xl font-bold font-serif">Agne's Portfolio</h1>
						<p className="py-6 text-base/loose text-center">
							Hello! Welcome to my Portfolio Website. I will be updating as
							soon as I have time, so if something is missing - please bare with
							me! Feel free to browse through my projects. If you have any
							questions at all, let me know!
						</p>
						<p className="mb-2">
							<i>ps. I will be adding images as soon as I can</i>
						</p>
						<Link to="/projects" className="btn btn-sm btn-primary me-5">
							Projects
						</Link>
						<button className="btn btn-sm btn-secondary me-5">
							<a href="https://github.com/AgnePK">Github</a>
						</button>
					</div>
				</div>
			</div>
		</>
	);
};
export default Hero;
